import React, { useContext, useEffect, useState } from "react";
import "./Transaction_History.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import Transaction_History_card from "./Transaction_History_card/Transaction_History_card";
import No_data from "../Common/No_data/No_data";
import { Context } from "../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import { GetAllWalletHistory } from "../../features/wallet/slice";
import { formatAmount, formatDate, formatNotifDate } from "../../utils/common";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";

function Transaction_History() {

  const transactionData = [
    {
      detail: "Game Moved Out",
      time: "2026-03-11 11:19:00",
      balance: "2.99",
      type: "out",
    },
    {
      detail: "Game Moved In",
      time: "2026-03-11 10:00:00",
      balance: "5.50",
      type: "in",
    },
    {
      detail: "Game Moved Out",
      time: "2026-03-10 09:30:00",
      balance: "1.20",
      type: "out",
    },
    {
      detail: "Game Moved In",
      time: "2026-03-09 07:10:00",
      balance: "10.00",
      type: "in",
    },
  ];

  const [showDate, setShowDate] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedApp, setSelectedApp] = useState("All");
  const { signin } = useContext(Context)

  const dispatch = useDispatch();

  const walletHistory = useSelector((state) => state.wallet);


  const fetch = async (page) => {
    await dispatch(GetAllWalletHistory({
      page,
      type: selectedApp?.id,
      startDate: selectedDate,
    }))
  };

  useEffect(() => {
    if (signin)
      fetch(1);
  }, [dispatch, signin, selectedApp, selectedDate]);


  const handlePageChange = async (page) => {
    fetch(page)
  };

  const options = [
    { label: "All", id: null },
    { label: "Withdrawal", id: 1 },      // Processing
    { label: "Commission", id: 2 },    // Accepted
    { label: "Deposit", id: 3 },
    { label: "Bet", id: 4 },
    { label: "Win", id: 5 },
  ];
  return (
    <>
      <section className="Transaction_History">
        <Common_white_header headingText={"Transaction History"} />

        <div className="container">

          <Filter_Drop
            options={options}
            showDate={showDate} setShowDate={setShowDate}
            showFilter={showFilter} setShowFilter={setShowFilter}
            selectedDate={selectedDate} setSelectedDate={setSelectedDate}
            selectedApp={selectedApp} setSelectedApp={setSelectedApp}

          />

          {walletHistory?.data?.length > 0 ?
            walletHistory?.data?.map((item, index) => (
              <Transaction_History_card
                key={index}
                detail={item.remark || ""}
                time={formatNotifDate(item.createdAt)}
                balance={formatAmount(item.amount)}
                platform_fee={formatAmount(item.platform_fee)}
                type={item.type}
                status={item.RequestStatus?.name}
                remark={item.remark || ""}
              />
            )) : <>
              <No_data />
              <button
                className="btn_details"
                onClick={() => { setSelectedDate(""); setSelectedApp("") }}
              >
                Reset details
              </button>
            </>}


          {walletHistory?.total_pages > 1 &&
            <CustomPagination currentPage={walletHistory?.current_page}
              totalPages={walletHistory?.total_pages}
              handlePageChange={handlePageChange} />}
        </div>
      </section>
    </>
  );
}

export default Transaction_History;